export const BENEFICIARIES_VALIDATION_RULES = {
  lastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  firstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  percentageSplit: {
    isRequiredTrim: {
      value: true,
    },
  },
  birthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  relationship: {
    isRequiredTrim: {
      value: true,
    },
  },
  fiduciaryLastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  fiduciaryFirstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  fiduciaryBirthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  fiduciaryRelationship: {
    isRequiredTrim: {
      value: true,
    },
  },
  isRevocable: {
    isRequiredBoolean: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/beneficiaries/beneficiariesValidationRules.js